import axios from '../../utils/axios';

export const getTextPaginateThunk = async (_, thunkApi) => {
  try {
    const { connectedAccount } = thunkApi.getState().user;
    const { page, limit } = thunkApi.getState().text.paginate;
    const res = await axios.get('/text/paginate', {
      params: {
        page,
        limit,
        author: connectedAccount,
      },
    });
    return res.data;
  } catch (err) {
    return thunkApi.rejectWithValue(err.response.data);
  }
};

export const deleteTextThunk = async (payload, thunkApi) => {
  try {
    const { connectedAccount } = thunkApi.getState().user;
    const { id } = payload;
    const res = await axios.delete(`/text/${id}`, {
      params: {
        author: connectedAccount,
      },
    });
    return res.data;
  } catch (err) {
    return thunkApi.rejectWithValue(err.response.data);
  }
};

export const validateTextThunk = async (payload, thunkApi) => {
  try {
    const { connectedAccount } = thunkApi.getState().user;
    const { id } = payload;
    const res = await axios.patch(`/text`, {
      author: connectedAccount,
      textId: id,
    });
    return res.data;
  } catch (err) {
    return thunkApi.rejectWithValue(err.response.data);
  }
};
